import React, { forwardRef, memo, useCallback, useMemo, useState } from "react";
import { TouchableOpacity } from "react-native";

import { useDevice } from "../_layout";

const HoverableTouchableOpacity = memo(
  forwardRef(function HoverableTouchableOpacity(
    {
      style,
      hoverStyle,
      disabled,
      onMouseEnter,
      onMouseLeave,
      children,
      ...props
    },
    ref
  ) {
    const { isMobile } = useDevice();
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = useCallback(
      (e) => {
        onMouseEnter?.(e);
        if (disabled) return;
        setIsHovered(true);
      },
      [onMouseEnter, disabled]
    );

    const handleMouseLeave = useCallback(
      (e) => {
        onMouseLeave?.(e);
        setIsHovered(false);
      },
      [onMouseLeave]
    );

    const combinedStyle = useMemo(() => {
      if (!isHovered || !hoverStyle) return style;
      return [style, hoverStyle];
    }, [style, hoverStyle, isHovered]);

    return (
      <TouchableOpacity
        ref={ref}
        {...props}
        disabled={disabled}
        style={combinedStyle}
        onMouseEnter={!isMobile ? handleMouseEnter : undefined}
        onMouseLeave={!isMobile ? handleMouseLeave : undefined}
      >
        {typeof children === "function" ? children(isHovered) : children}
      </TouchableOpacity>
    );
  })
);

HoverableTouchableOpacity.displayName = "HoverableTouchableOpacity";

export default HoverableTouchableOpacity;
